import { render } from "./Bps.vue?vue&type=template&id=0b44d551&scoped=true"
import script from "./Bps.vue?vue&type=script&lang=js"
export * from "./Bps.vue?vue&type=script&lang=js"

import "./Bps.vue?vue&type=style&index=0&id=0b44d551&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b44d551"]])

export default __exports__